import * as React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react';


interface Props {
  cars: LoanCar[];
  onChange: (selectedCar: LoanCar | undefined) => void;
  car: LoanCar | undefined;
}

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: { width: 300, maxWidth: '100%' },
};

export const LoanCarDropdown: React.FC<Props> = ({ cars, onChange, car }) => {
 

  const options: IDropdownOption[] = cars.map((car) => ({
    key: car.id,
    text: `${car.regNumber} - ${car.make} ${car.model}`,
  }));

  const handleChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {

    const selectedCar = cars.find((car) => option && car.id ===  option.key);
    onChange(selectedCar);
  };

  return (
    <Dropdown
      placeholder="Vælg lånebil"
      options={options}
      selectedKey={car && car.id}
      onChange={handleChange}
      styles={dropdownStyles}
    />
  );
};
